import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=33e9db4e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=33e9db4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e9db4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e9db4e')) {
      api.createRecord('33e9db4e', component.options)
    } else {
      api.reload('33e9db4e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=33e9db4e&scoped=true&", function () {
      api.rerender('33e9db4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UNeZ49iqPoqd/JS/comp/DocBox.vue"
export default component.exports